import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import APIS from "../../../../../constant/Endpoint";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  const formResponse = await getApiData(APIS.FORMS, {});
  Components.addType("contact-us", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("contact-us")
      ) {
        return {
          type: "contact-us",
        };
      }
    },
    model: {
      defaults: {
        tagName: "main",
        classes: ["contact-us"],
        components: /*html*/ `
            <section class="container mx-auto px-4 py-6 flex-1">
              <h2 class="text-2xl font-bold mb-4">
                Have Questions? We’re Here to Help!
              </h2>
              <p class="mb-6 text-gray-600 text-xl">
                Let’s simplify your logistics! Fill out the form, and we’ll get
                back to you shortly.
              </p>
              <div class="flex flex-col items-center  justify-center md:flex-row bg-white gap-8">
                <div class="flex-1">
                  <form
                    class="flex flex-col gap-4 md:px-10 p-6 md:py-6  mx-auto max-w-[500px] rounded-lg shadow-[0px_2px_8px_3px_rgba(0,0,0,0.25)] "
                  >
                    <label class="block">
                      <span class="text-gray-900">Full name*</span>
                      <input
                        type="text"
                        name="full_name"
                        id="full_name"
                        placeholder="eg: (Sam Smith)"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900">Phone no.*</span>
                      <input
                        type="tel"
                        name="phone_number"
                        id="phone_number"
                        placeholder="eg: (+9779825677664)"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900">Email</span>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="eg: (user@gmail.com)"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded"
                      />
                    </label>
                    <label class="block">
                      <textarea
                        class="mt-1 block w-full p-2 border border-gray-300 rounded"
                        placeholder="Enter your message"
                        name="message"
                        id="message"
                        rows="4"
                      ></textarea>
                    </label>
                    <button
                      type="submit"
                      class="bg-purple-700 text-white p-3 rounded hover:bg-purple-800"
                    >
                      Send Message
                    </button>
                  </form>
                </div>
                <div class="flex-1 space-y-4">
                  <div>
                    <h3 class="text-xl font-semibold">Contact Details</h3>
                    <p>Phone: 977-9876512345</p>
                    <p>Email: logistics@gmail.com</p>
                    <p>Office Address: Kathmandu, Nepal</p>
                  </div>
                  <div>
                    <h3 class="text-xl font-semibold">Business Hours</h3>
                    <p>Sunday - Saturday (10 AM - 6 PM)</p>
                  </div>

                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3532.403481047893!2d85.32166269999999!3d27.704825999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb1900046d723b%3A0xa1ac6c5d26d792a7!2sYatri%20express!5e0!3m2!1sen!2snp!4v1739781338854!5m2!1sen!2snp"
                    class="rounded-lg w-full h-76 rounded-lg overflow-hidden"
                    frameborder="0"
                    style="border:0"
                    allowfullscreen=""
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </section>

        `,

        script: function () {
          const formType = document
            .querySelector(".contact-us")
            .getAttribute("form-type");
          const form = document.querySelector("form") as HTMLFormElement;
          let validator;
          const initLib = function () {
            //@ts-ignore
            validator = new JustValidate(form);
            validator
              .addField(document.querySelector("#full_name"), [
                {
                  rule: "required",
                  errorMessage: "Full name is required",
                },
              ])
              .addField(document.querySelector("#phone_number"), [
                {
                  rule: "required",
                  errorMessage: "Phone number is required",
                },
                {
                  rule: "custom",
                  validator: (value) => /^\+977\d{9,10}$/.test(value),
                  errorMessage: "Enter a valid phone number",
                },
              ]);
          };
          const initToastLib = function () {};
          const showToast = function (toastMessage, color) {
            //@ts-ignore
            Toastify({
              text: `${toastMessage}`,
              duration: 2000,
              close: false,
              gravity: "top",
              position: "right",
              stopOnFocus: true,
              offset: {
                x: 20,
                y: 60,
              },
              style: {
                background: `${color}`,
              },
            }).showToast();
          };

          form.addEventListener("submit", function (e) {
            e.preventDefault();
            const formData = new FormData(form);
            const data = {};
            formData.forEach((value, key) => {
              data[key] = value;
            });
            validator.onSuccess((isValid) => {
              if (!isValid) {
                console.log("Form validation failed.");
                return;
              }
              fetch("{% url 'save_form' %}", {
                method: "POST",
                body: JSON.stringify({
                  form_data: data,
                  form: formType,
                }),
              })
                .then(function (response) {
                  if (!response.ok) {
                    return Promise.reject("Contactus submission failed.");
                  }
                  return response.json();
                })
                .then(function (result) {
                  console.log("Response:", result);
                  showToast("Submitted successfully ", "green");
                })
                .catch(function (error) {
                  console.error("Error submitting checkout:", error);
                });
            });
          });
          //@ts-ignore
          if (typeof Toastify === "undefined") {
            const script = document.createElement("script");
            script.onload = initToastLib;
            script.src = "https://cdn.jsdelivr.net/npm/toastify-js";
            document.body.appendChild(script);
          } else {
            initToastLib();
          }
          //@ts-ignore
          if (typeof JustValidate === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://unpkg.com/just-validate@latest/dist/just-validate.production.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
      async init() {
        this.loadTraitOptions();
      },
      async loadTraitOptions() {
        const formResponse = await getApiData(APIS.FORMS, {});
        this.set("traits", [
          {
            type: "select",
            label: "Select form",
            name: "form-type",
            options: formResponse?.data ?? [],
          },
        ]);
      },
    },
  });
};
